export const makePascalCase = (string = "") => {
  return string
    .split(" ")
    .map(str => str.charAt(0).toUpperCase() + str.slice(1))
    .join("");
};

export const sanitizeText = (string = "") => {
  let p = document.createElement("p");
  p.innerHTML = string;

  return p.textContent;
};
